import { VariantProps, cva } from "class-variance-authority";

import { cn } from "@/common/utils/css.utils";

/**
 * Notion 09.2 Info panel, rebuilt from Figma `9512:6245` (Dieke, 2026-09-08;
 * WHO-5550): 50-tint background per tone, radius 0, 8px padding, a 24x24
 * icon in the panel's own text colour. Links inside the message inherit that
 * colour too. A panel carries no buttons: an action belongs in the page's
 * action row, and the panel links at most one route inside its text.
 */
const PanelStyle = cva("flex items-center space-x-1 p-2", {
  variants: {
    color: {
      burst: "bg-burst-50 text-burst-900",
      curious: "bg-curious-50 text-curious-800",
      brand: "bg-flavour-50 text-brand-600",
      attention: "bg-attention-50 text-attention-900",
    },
    corners: {
      rounded: "rounded-[0.25rem]",
      square: "",
    },
  },
  defaultVariants: {
    color: "curious",
    corners: "square",
  },
});

export type InfoPanelProps = {
  icon?: JSX.Element;
  body?: JSX.Element;
  className?: string;
} & VariantProps<typeof PanelStyle>;

export const InfoPanel = ({
  color,
  corners,
  icon,
  body,
  className,
}: InfoPanelProps) => {
  return (
    <div
      className={cn(
        PanelStyle({ color, corners }),
        "flex flex-col items-start",
        className
      )}
    >
      <div className="grid grid-cols-[auto_1fr] gap-x-2 gap-y-5">
        {icon}
        {body}
      </div>
    </div>
  );
};
